const getBaseURL = () => {
  if (typeof window !== 'undefined') {
    const url = new URL(window.location.href);
    const baseURL = url.origin;
    return baseURL;
  }
  return '';
};
export default getBaseURL;
